import { DatePicker, message, Modal } from "antd";
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import dayjs from "dayjs";
import axiosInstance from "../../../variables/api/axiosInstance";
import TextArea from "antd/es/input/TextArea";
import { rightsService } from "../../../services/rightsService";
const AnnulerCheque = (prop) => {
    const [modalDecaissementSinistre, setModalDecaissementSinistre] = useState(
        false
    );
    const [loading, setLoading] = useState(false);
    const [motif, setMotif] = useState('');
    // Date d'annulation : antidatable UNIQUEMENT avec l'habilitation HSI095 (mêmes règles que
    // l'antidatage de règlement — le backend refuse une période déjà cédée). Défaut = aujourd'hui.
    const peutAntidater = rightsService("HSI095");
    const [dateAnnulation, setDateAnnulation] = useState(dayjs());


    const handleAnnulerChequeSubmit = async () => {
        setLoading(true);
        const decaissement = prop?.decaissement;
        if (!decaissement) {
            message.error("Erreur lors de l'annulation du chèque");
            setLoading(false);
            return;
        }

        if (!motif || motif.trim() === "") {
            message.error("Motif d'annulation obligatoire");
            setLoading(false);
            return;
        }

        const dto = {
            codeId: decaissement.codeId,
            numeroCheque: decaissement.numeroCheque,
            banque: decaissement.banque,
            motifAnnulerCheque: motif.trim(),
            // Envoyée seulement si antidatée (≠ aujourd'hui) ET habilité HSI095 ; sinon le backend
            // utilise la date du jour. Format LocalDate = YYYY-MM-DD.
            dateAnnulation: (peutAntidater && dateAnnulation && !dateAnnulation.isSame(dayjs(), "day"))
                ? dateAnnulation.format("YYYY-MM-DD") : undefined,
        };

        try {
            await axiosInstance.put(
                `/api/decaissement/annuler-cheque`,
                JSON.stringify(dto),
                { headers: { 'Content-Type': 'application/json' } }
            );
            message.success("Annulation de chèque effectuée avec succès");
            if (prop.onSuccess) prop.onSuccess();
            else window.location.reload();
        } catch (err) {
            console.log(err);
            const msg = err?.response?.data?.message || "Erreur lors de l'annulation du chèque";
            message.error(msg);
        } finally {
            setLoading(false);
        }
    };



    useEffect(() => {
        console.log(prop.decaissement);
        setModalDecaissementSinistre(prop.open);
    }, [prop.open]);

    return (
        <Modal
            title="Effectuer l'annulation de chèque"
            confirmLoading={loading}
            centered
            open={modalDecaissementSinistre}
            onOk={() => handleAnnulerChequeSubmit()}
            onCancel={prop.onCancel}
            okText={"Effectuer"}
            cancelText={"Annuler"}
            width={900}
        >
            <div className="row">
                <div className="col-12">
                    <label className="control-label">Motif de l'annulation</label>
                    <TextArea
                        id="motif"
                        formControlProps={{
                            fullWidth: true,
                        }}
                        name="motif"
                        value={motif}
                        onChange={(event) => {
                            setMotif(event.target.value);
                        }}
                    />
                </div>
                {peutAntidater && (
                    <div className="col-12" style={{ marginTop: 12 }}>
                        <label className="control-label">Date d'annulation (antidatage, HSI095)</label>
                        <DatePicker
                            style={{ width: "100%" }}
                            allowClear={false}
                            format="DD/MM/YYYY"
                            value={dateAnnulation}
                            disabledDate={(d) => d && d.isAfter(dayjs(), "day")}
                            onChange={(d) => setDateAnnulation(d || dayjs())}
                        />
                        <div style={{ fontSize: 12, color: "#888", marginTop: 4 }}>
                            La contre-passation tombera sur cette période. Refusée si le mois est déjà cédé.
                        </div>
                    </div>
                )}
                <br />
            </div>
        </Modal>
    );
};

AnnulerCheque.propTypes = {
    open: PropTypes.bool,
    // setOpen: PropTypes.func,
    decaissement: PropTypes.object,
    sinistre: PropTypes.object,
};

export default AnnulerCheque;
